// extracted by mini-css-extract-plugin
export var divider = "_vr-0";